module.exports = __webpack_public_path__ + "fonts/miller-displayroman-webfont.463a5b9e02b8b4a8bb0786100f8b2abb.woff2";